import { gtmPageView, gtmCustomEvent } from '@/components/GoogleTagManager';

// Simple page view tracking (GTM only)
export const trackPageView = (url: string) => {
  gtmPageView(url);
};

// Simple event tracking (GTM handles the rest)
export const trackEvent = (eventName: string, parameters: Record<string, unknown> = {}) => {
  gtmCustomEvent(eventName, parameters);
};

// Session initialization
export const initializeSession = () => {
  if (typeof window !== 'undefined' && !sessionStorage.getItem('session_id')) {
    sessionStorage.setItem('session_id', `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`);
  }
};

// Initialize session when module loads
if (typeof window !== 'undefined') {
  initializeSession();
} 